import { render, staticRenderFns } from "./adminLayout.pug?vue&type=template&id=998af41c&lang=pug&"
import script from "./adminLayout.js?vue&type=script&lang=js&"
export * from "./adminLayout.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('998af41c')) {
      api.createRecord('998af41c', component.options)
    } else {
      api.reload('998af41c', component.options)
    }
    module.hot.accept("./adminLayout.pug?vue&type=template&id=998af41c&lang=pug&", function () {
      api.rerender('998af41c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/index.vue"
export default component.exports